import { Injectable } from '@angular/core';
import { CreateSectionMessage, CreateSectionReview, SectionIdentifier, SectionMessage, SectionReview } from './review-section.domain';
import { CommunicationService } from 'src/app/services/communication.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReviewSectionService {
  constructor(private communicationService: CommunicationService) {}

  public getSectionMessages(applicationId: number | string, sections: SectionIdentifier[] = null): Observable<SectionMessage[]> {
    if (!sections || !sections.length) {
      return this.communicationService.getData(`sectionmessage/${applicationId}`);
    }

    return this.communicationService.getData(`sectionmessage/${applicationId}?sections=${sections.join(',')}`);
  }

  public createSectionMessage(message: CreateSectionMessage): Observable<SectionMessage> {
    return this.communicationService.postData('sectionmessage', message);
  }

  public getSectionReviews(applicationId: number | string): Observable<SectionReview[]> {
    return this.communicationService.getData(`sectionreview/${applicationId}`);
  }

  public createSectionReview(review: CreateSectionReview): Observable<SectionReview> {
    return this.communicationService.postData('sectionreview', review);
  }
}
